import React from 'react';
import profileImage from '../assets/profiledp.webp';

const Home = () => {
  return (
    <section className="home" id="home">
      <div className="supply-chain-bg" aria-hidden="true">
        <div className="control-tower-panel">
          <span>Control Tower</span>
          <strong>Supply Chain Analytics</strong>
          <div className="tower-row"><i></i>Stockout Risk</div>
          <div className="tower-row"><i></i>PO Aging</div>
          <div className="tower-row"><i></i>Reorder Alerts</div>
        </div>
        <span className="route-track route-track-one"></span>
        <span className="route-track route-track-two"></span>
        <span className="route-node node-supplier">Supplier</span>
        <span className="route-node node-warehouse">Warehouse</span>
        <span className="route-node node-fulfillment">Fulfillment</span>
        <span className="route-node node-kpi">KPI</span>
        <span className="route-pulse pulse-one"></span>
        <span className="route-pulse pulse-two"></span>
      </div>
      <div className="home-content">
        <h3>Hi, Myself</h3>
        <h1>Damith Wijekoon</h1>
        <h3>And I'm a <span className="multiple-text"></span></h3>
        <p>
          I develop practical Excel and Power BI dashboards for logistics and supply chain operations. My projects focus on inventory control, warehouse accuracy, order fulfillment, OTIF performance, and operational KPI reporting to support data-driven decision-making.
        </p>
        <div className="social-media">
          <a href="https://www.facebook.com/Damithwijekoon11/" target="_blank" rel="noopener noreferrer">
            <i className="fa-brands fa-facebook"></i>
          </a>

          <a href="https://wa.me/94766213650" target="_blank" rel="noopener noreferrer">
            <i className="fa-brands fa-whatsapp"></i>
          </a>
          <a href="https://www.linkedin.com/in/damith-wijekoon-06a522216/" target="_blank" rel="noopener noreferrer">
            <i className="fa-brands fa-linkedin-in"></i>
          </a>
        </div>
        <a href="https://www.linkedin.com/in/damith-wijekoon-06a522216/" target="_blank" rel="noopener noreferrer" className="btn">Hire Me</a>
      </div>
      <div className="home-img">
        <img src={profileImage} alt="profile" width="700" height="700" decoding="async" />
      </div>
    </section>
  );
};

export default Home;
